import { atom } from "recoil";
import { recoilPersist } from "recoil-persist";
import { constant } from "../../utils/utils";
const { persistAtom } = recoilPersist({ storage: localStorage });
// const { persistAtom } = recoilPersist([
//   { key: "userBlocker", storage: localStorage },
//   {
//     key: "userDetail",
//     storage: sessionStorage,
//   },
// ]);

export const userDetail = atom({
  key: "userDetail", //this key value we have added as a constant on utils file
  default: null,
  effects_UNSTABLE: [persistAtom],
});

export const userBlocker = atom({
  key: "userBlocker", //this key value we have added as a constant on utils file
  default: null,
  effects_UNSTABLE: [persistAtom],
});

export const appTheme = atom({
  key: "appTheme", //this key value we have added as a constant on utils file
  default: null,
  effects_UNSTABLE: [persistAtom],
});
export const userGSTDetails = atom({
  key: "userGSTDetails", //this key value we have added as a constant on utils file
  default: null,
  effects_UNSTABLE: [persistAtom],
});

export const userUdyamDetails = atom({
  key: "userUdyamDetails", //this key value we have added as a constant on utils file
  default: null,
  effects_UNSTABLE: [persistAtom],
});

export const userAadharDetails = atom({
  key: "userAadharDetails", //this key value we have added as a constant on utils file
  default: null,
  effects_UNSTABLE: [persistAtom],
});
